import React from 'react'
import GRISidebar from '../../../Layout/GRISidebar'
import ReviewPage from '../../../Components/Common/ReviewPage'
import { useGRI } from '../../../context/GRIContext';



const GRIReview = () => {
  const { griId } = useGRI();
  return (
   <ReviewPage component={<GRISidebar />} module={"GRI"}  url={`/gri/general-disclosure/2-1/${griId}`} url1={"/gri"}/>
  )
}

export default GRIReview